import React from 'react';
import WebsiteNavbar from './lib/html/WebsiteNavbar';
import WebsiteFooter from './lib/html/WebsiteFooter';
import DemoScheduler from './DemoScheduler';
import '../../css/home_page.css';
const keepManagementState=()=>{};
export default function DemoManagementPage() {
  return <div id="homepage-content">
    <WebsiteNavbar />
    <main className="homepage-banner light-gray" style={{padding:'32px 16px'}}>
      <div className="demo-contact-card" style={{maxWidth:900,margin:'0 auto'}}>
        <h1>Manage your Edario demo</h1>
        <DemoScheduler managementOnly onState={keepManagementState} />
      </div>
    </main>
    <WebsiteFooter />
  </div>;
}
